<template>
  <main class="cart-page page">
    <div class="page__inner container-padding">
      <h1>Корзина</h1>
    </div>
    <div class="page__inner container-padding cart-page__container">
      <template v-if="!ordering">
        <span v-show="!cartItems.length" class="cart-page__empty">Корзина пуста</span>
        <div v-show="cartItems.length" class="cart-page__main">
          <CartHeaderComponent />
          <div class="cart-page__items">
            <CartItemComponent v-for="(item, i) in cartItems" :key="i" :data="item" />
          </div>
        </div>
      </template>
      <template v-else>
        <div class="cart-page__main">
          <!--          <div class="cart-page__wrapper">-->
          <!--            <h6>Способ получения</h6>-->
          <!--            <CartTabsComponent-->
          <!--              :tabs="firstTabs"-->
          <!--              :active-tab="firstActiveTab"-->
          <!--              @changeTab="($event) => (firstActiveTab = $event)"-->
          <!--            />-->
          <!--          </div>-->
          <div class="cart-page__wrapper">
            <h6>Адрес и доставка</h6>
            <div class="cart-page__wrapper-col-2">
              <InputComponent v-model="form.city.value" :errors="form.city.errors" placeholder="Город" />
              <InputComponent
                v-model="form.street.value"
                :errors="form.street.errors"
                placeholder="Улица, дом"
              />
            </div>
            <div class="cart-page__wrapper-col-3">
              <InputComponent
                v-model="form.flat.value"
                :errors="form.flat.errors"
                placeholder="Квартира/Офис"
              />
              <InputComponent
                v-model="form.entrance.value"
                :errors="form.entrance.errors"
                placeholder="Подъезд"
              />
              <InputComponent v-model="form.floor.value" :errors="form.floor.errors" placeholder="Этаж" />
            </div>
            <InputComponent
              v-model="form.comment.value"
              :errors="form.comment.errors"
              placeholder="Комментарий (например, код от домофона)"
            />
          </div>
          <!--          <div class="cart-page__wrapper">-->
          <!--            <h6>Способ оплаты</h6>-->
          <!--            <CartTabsComponent-->
          <!--              :tabs="secondTabs"-->
          <!--              :active-tab="secondActiveTab"-->
          <!--              @changeTab="($event) => (secondActiveTab = $event)"-->
          <!--            />-->
          <!--          </div>-->
          <div class="cart-page__wrapper">
            <h6>Покупатель</h6>
            <InputComponent v-model="form.fio.value" :errors="form.fio.errors" placeholder="Имя Фамилия*" />
            <InputComponent
              v-model="form.phone.value"
              :errors="form.phone.errors"
              mask="+7 (###) ### ## ##"
              placeholder="Телефон*"
            />
            <InputComponent
              v-model="form.email.value"
              :errors="form.email.errors"
              placeholder="Электронный адрес*"
            />
          </div>
        </div>
      </template>
      <CartAsideComponent
        :loading="loading"
        @order-create="submit"
        :ordering="ordering"
        @toOrdering="($event) => (ordering = $event)"
      />
    </div>
  </main>
</template>

<script>
import CartHeaderComponent from "./components/CartHeaderComponent.vue";
import CartAsideComponent from "./components/CartAsideComponent.vue";
import CartItemComponent from "./components/CartItemComponent.vue";
import InputComponent from "components/inputs/InputComponent.vue";
import CartTabsComponent from "./components/CartTabsComponent.vue";
import NotificationModal from "components/modal/components/NotificationModal.vue";
import POST from "@/graphql/mutations/OrderCreate.graphql";

export default {
  name: "CartPage",
  data() {
    return {
      loading: false,
      ordering: false,
      firstTabs: ["Самовывоз", "Доставка"],
      firstActiveTab: 2,
      secondTabs: ["Банковская карта", "Наличными"],
      secondActiveTab: 1,
      form: {
        fio: {
          value: null,
          errors: [],
        },
        phone: {
          value: null,
          errors: [],
        },
        email: {
          value: null,
          errors: [],
        },
        delivery_type_id: {
          value: null,
          errors: [],
        },
        street: {
          value: null,
          errors: [],
        },
        flat: {
          value: null,
          errors: [],
        },
        entrance: {
          value: null,
          errors: [],
        },
        floor: {
          value: null,
          errors: [],
        },
        comment: {
          value: null,
          errors: [],
        },
        city: {
          value: null,
          errors: [],
        },
      },
    };
  },
  mounted() {
    if (this.isRegistered) {
      this.setUserData();
    }
  },
  methods: {
    resetErrors() {
      Object.keys(this.form).forEach((key) => {
        this.form[key].errors = [];
      });
    },
    setUserData() {
      this.form.fio.value = this.user.name;
      this.form.phone.value = this.user.phone;
      this.form.email.value = this.user.email;
    },
    submit() {
      this.loading = true;
      this.resetErrors();
      this.$apollo
        .mutate({
          mutation: POST,
          context: {
            headers: {
              Authorization: "Bearer " + this.$store.state.apollo_token,
            },
          },
          variables: {
            fio: this.form.fio.value,
            phone: this.form.phone.value,
            email: this.form.email.value,
            street: this.form.street.value,
            comment: this.form.comment.value,
            entrance: this.form.entrance.value,
            floor: this.form.floor.value,
            flat: this.form.flat.value,
            delivery_type_id: this.firstActiveTab,
            city: this.form.city.value,
          },
        })
        .then(async () => {
          this.loading = false;
          await this.$router.push({ name: "profile" });
          this.$store.state._modals.push({
            component: NotificationModal,
            options: {
              title: "Заказ успешно оформлен",
              description: "Отслеживать состояние заказа можно в личном кабинете",
            },
          });
          let apollo = this.$apollo.provider;
          await this.$store.dispatch("USER", {
            apollo,
          });
        })
        .catch(({ graphQLErrors }) => {
          this.parseGqlErrors(graphQLErrors);
          this.loading = false;
        });
    },
    parseGqlErrors(graphQLErrors) {
      graphQLErrors.forEach((err) => {
        if (err.extensions.category === "validation") {
          Object.keys(err.extensions.validation).forEach((key) => {
            if (this.form[key]) {
              this.form[key].errors.push(err.extensions.validation[key][0]);
            }
          });
        }
      });
    },
  },
  computed: {
    cartItems() {
      return this.$store.state.auth.cart;
    },
    user() {
      return this.$store.state.auth.user;
    },
    isRegistered() {
      return this.$store.state.auth.user ? this.$store.state.auth.user.email : false;
    },
  },
  components: {
    CartHeaderComponent,
    CartAsideComponent,
    CartItemComponent,
    InputComponent,
    CartTabsComponent,
  },
};
</script>

<style lang="stylus">
.cart-page {
  background var(--white-2)
  padding 80px 0

  &__empty {
    padding: 50px 20px
    font-size 1.25rem
  }

  &__container {
    display grid
    grid-template-columns 950fr 460fr
    gap 30px

    +below(1024px) {
      grid-template-columns 1fr
      padding 0
    }
  }

  &__main {
    display flex
    flex-direction column
    gap 30px
  }

  &__items {
    display grid
    grid-template-columns 1fr
    gap 30px

    +below(1024px) {
      grid-template-columns 1fr 1fr
    }

    +below(800px) {
      grid-template-columns 1fr
    }
  }

  &__wrapper {
    background var(--white)
    border-radius 20px
    padding 30px
    display flex
    flex-direction column
    gap 30px

    .select__field-container {
      height: 42px;
    }

    &-col-3 {
      display grid
      grid-template-columns repeat(3, 1fr)
      gap 26px
    }

    &-col-2 {
      display grid
      grid-template-columns repeat(2, 1fr)
      gap 26px
    }

    h6 {
      font-weight: 600;
      font-size: 1.250em;
      line-height: 160%;
      text-transform none
    }
  }
}
</style>
